import { render, staticRenderFns } from "./HistoryEM.vue?vue&type=template&id=ca23fb8e&scoped=true"
import script from "./HistoryEM.vue?vue&type=script&lang=js"
export * from "./HistoryEM.vue?vue&type=script&lang=js"
import style0 from "./HistoryEM.vue?vue&type=style&index=0&id=ca23fb8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca23fb8e",
  null
  
)

export default component.exports